/**
 * Escape a value for CSV (quotes and commas).
 * @param {*} value
 * @returns {string}
 */
function escapeCsvValue(value) {
  if (value == null) return "";
  const str = String(value);
  if (str.includes('"') || str.includes(",") || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * Build CSV string from rows and headers.
 * @param {Object[]} data - Array of row objects
 * @param {string[]} headers - Column keys (in order)
 * @param {(row: Object, key: string) => *} [getCellValue] - Optional: (row, headerKey) => value; default is row[key]
 * @returns {string}
 */
export function buildCsv(data, headers, getCellValue = (row, key) => row[key]) {
  if (!data.length || !headers.length) return "";
  const rows = data.map((row) =>
    headers.map((key) => escapeCsvValue(getCellValue(row, key))).join(",")
  );
  return [headers.join(","), ...rows].join("\n");
}

/**
 * Trigger browser download of a CSV file.
 * @param {Object[]} data - Array of row objects
 * @param {{ headers: string[], filename: string, getCellValue?: (row: Object, key: string) => * }} options
 * @returns {boolean} - true if download was triggered, false if no data
 */
export function exportToCsv(data, { headers, filename, getCellValue }) {
  if (!data?.length) return false;
  const csvContent = buildCsv(data, headers, getCellValue);
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || `export-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
}
